module.exports = __webpack_public_path__ + "static/media/email.4684dc87.svg";